export const CAMPAIGN_LIST_POST = 'campaigns/list';
export const CONTENT_STUDIO_GET = '/campaigns/content_studio_list';
export const CAMPAIGN_DETAILS_GET = 'campaigns/detail';
export const CAMPAIGN_ADD_POST = 'campaigns/add';
export const CAMPAIGN_UPDATE_POST = 'campaigns/update';
export const CAMPAIGN_SEGMENT_LIST_POST = 'campaigns/segment_list';
export const CAMPAIGN_CONTENT_STUDIO_TEMPLATE_PREVIEW_GET = 'campaigns/get_template';
export const CAMPAIGN_STUDIO_CHECK_FIT_GET = 'campaigns/check_fit'